// ======================================================================
// File Name       : serviceRecord
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import * as ActionTypes from '../constants/actionTypes/serviceRecord';
import { RETURN_MAX_NUM, DEFAULT_YEAR_MONTH } from '../constants/index';
import { now } from '../utils/ServiceRecordUtils';

const initialState = {
  searchInfo: {
    selectTargetMonth: now.format(DEFAULT_YEAR_MONTH),
    serviceCdList: [],
  },
  searchResult: [],
  selectTargetMonth: '',
  targetMonths: [],
  showExportModal: false,
  downloadForm: {},
  monthList: [],
  downloadFormMonthList: [],
  serviceInfo: {
    recordNum: 0,
    serviceList: [],
  },
};

export default function serviceRecord(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SERVICE_RECORD_RECEIVE_LIST: {
      const { data, url } = action;
      return {
        ...state,
        searchResult: {
          ...state.searchResult,
          [url]: data,
        },
      };
    }
    case ActionTypes.REINITIALIZE_FORM: {
      const { newEnterpriseCd, newServiceCd } = action;
      return {
        ...state,
        ...{ newEnterpriseCd },
        ...{ newServiceCd },
      };
    }
    case ActionTypes.SAVE_SYSTEM_USAGE_MONTHS: {
      const { systemUsageMonths } = action;
      return {
        ...state,
        ...{ systemUsageMonths },
      };
    }
    case ActionTypes.SERVICE_DOWNLOAD_FORM: {
      const { downloadForm } = action;
      return { ...state, ...{ downloadForm } };
    }

    case ActionTypes.SERVICE_MONTH_LIST: {
      const { monthList } = action;
      return { ...state, ...{ monthList } };
    }

    case ActionTypes.SERVICE_DOWNLOAD_FORM_MONTH_LIST: {
      const { downloadFormMonthList } = action;
      return { ...state, ...{ downloadFormMonthList } };
    }

    case ActionTypes.SERVICE_EDITING_LIST: {
      const { serviceInfo } = action;
      return { ...state, ...{ serviceInfo } };
    }
    default:
      return state;
  }
}
